import Vue from 'vue'
import op from 'object-path'

/**
    @filter 求卡面价格，包括单位
    @param {CardDetail} card 传入整个卡详情对象
 */
Vue.filter('cardPrice' ,card => {
    if(card.displayType == 1) {
        return `${card.count}||张票`
    } else if (card.displayType == 4) {
        return `${card.count}||份礼包`
    } else {
      let price = Math.round(card.cardBalance)/100;//Math.floor(card.cardBalance/100)
        price = price.toFixed(2) + ""
        let stringPrice = price.split(".")
        if(stringPrice[1] != '00'){
            return `${stringPrice[0]}|${stringPrice[1]}|元`
        }
        return `${stringPrice[0]}||元`
    }
})

/**
    @filter 求卡面价格，包括单位，价格取可用最大值
    @param {CardDetail} card 传入整个卡详情对象
 */
Vue.filter('cardShowPrice' ,card => {
    if(card.displayType == 1) {
        return `${card.count}||张票`
    } else if (card.displayType == 4) {
        return `${card.count}||份礼包`
    } else {
        let price
        if (card.displayType == 3) {
          price = Math.round(card.category.showPrice)/100;
          price = price.toFixed(2) + ""
          let stringPrice = price.split(".")
          if(stringPrice[1] != '00'){
              return `${stringPrice[0]}|${stringPrice[1]}|${card.unit}`
          }
          return `${stringPrice[0]}||${card.unit}`

        } else {
          price = Math.round(card.cardBalance)/100;
          price = price.toFixed(2) + ""
          let stringPrice = price.split(".")
          if(stringPrice[1] != '00'){
              return `${stringPrice[0]}|${stringPrice[1]}|${card.unit}`
          }
          return `${stringPrice[0]}||${card.unit}`
        }
        // price = price.toFixed(2) + ""
        // let stringPrice = price.split(".")
        // if(stringPrice[1] != '00'){
        //     return `${stringPrice[0]}|${stringPrice[1]}|元`
        // }
        // return `${stringPrice[0]}||元`
    }
})


/**
    @filter 返回卡价格的整数部分
    @param {string} info 过滤器’cardPrice‘ 的返回结果
 */
Vue.filter('cardPriceFrist', info => {
    return info.split("|")[0]
})


/**
 *    @filter 返回卡价格的小数部分
 *   @param {string} info 过滤器’cardPrice‘ 的返回结果
 */
Vue.filter('cardPriceSecond', info => {
    if(!info.split("|")[1]){
        return ""
    }
    return `.${info.split("|")[1]}`
})

/**
 *    @filter 返回卡价格的单位部分
 *   @param {string} info 过滤器’cardPrice‘ 的返回结果
 */
Vue.filter('cardPriceThird', info => {
    return ` ${info.split("|")[2]}`
})


/**
    @filter 依据卡类型返回对应的水印图片文件路径
    @param {CardDetail} 整个卡详情对象
 */
Vue.filter('cardWatermark', card => {
    let categoryId = op(card).get("category.categoryId") || 1
    let fileName = card.validFlag == 1 ? 'useful':'useless'
    switch(categoryId) {
        case 1:return require(`../../image/card/watermark/${fileName}/film.png`);break;//电影卡
        case 2:return '';break;//充值卡，
        case 3:return require(`../../image/card/watermark/${fileName}/fruit.png`);break;//水果卡，
        case 4:return require(`../../image/card/watermark/${fileName}/book.png`);break;//图书卡，
        case 5:return '';break; //食品卡
        case 6:return require(`../../image/card/watermark/${fileName}/labor.png`);break;//劳保卡，
        case 7:return '';break; //居家卡，
        case 8:return '';break; //餐厨卡，
        case 9: return require(`../../image/card/watermark/${fileName}/cake.png`);break;//蛋糕卡，
        case 10: return require(`../../image/card/watermark/${fileName}/gift.png`);break;//礼包福利通卡，
        case 10000:return require(`../../image/card/watermark/${fileName}/general.png`);break; //商城通卡
        case 10001:return require(`../../image/card/watermark/${fileName}/general.png`);break; //多品类卡
        default: return '';break;
    }
})

/**
    @filter 判断水印标签img是否显示
    @param {string} img 过滤器cardWatermark的返回结果
 */
Vue.filter('hideWatermark',img => {
    if(!img){
        return 'hidden'
    }
    return false
})

/**
    @filter 卡号的样式修改，在第四位后面插入空格
    @param {string} num 卡号
 */
Vue.filter('cardNum', num => {
    if(!num){
        return ''
    }
    let n = num.split('')
    n.splice(4,0," ")
    return n.join("")
})

/**
    @filter 解析卡/券抵扣信息，包括单位
    @param {c} card/coupon 传入卡/券抵扣详情对象
    @param {key} 需要进行解析的字段
 */
Vue.filter('priceDeduction' ,(c, valueKey, countKey) => {
  if(!c[valueKey] && c[countKey]) {
      if (c.displayType == 4) { //1: 旧卖座次卡 2.旧卖座储值卡 3:礼品卡,4:礼包卡
        return `${c[countKey]}||份礼包`
      } else {
        return `${c[countKey]}||张票`
      }
  }else {
      let price = Math.round(c[valueKey])/100
      price = price.toFixed(2) + ""
      return price.split(".").join("|")
      /* let stringPrice = price.split(".")
      if(stringPrice[1] != '00'){
          return `${stringPrice[0]}|${stringPrice[1]}`
      }
      return `${stringPrice[0]}` */
  }
})

/**
    @filter 解析卡，包括单位，与 priceDeduction 有细微差别
    @param {c} card/coupon 传入卡扣详情对象
    @param {key} 需要进行解析的字段
 */
Vue.filter('cardDeduction' ,(c, valueKey, countKey, optionKey) => {
  let targetValue = !optionKey ? c[valueKey] : c[optionKey]
  if(!targetValue && c[countKey]) {
      if (c.displayType == 4) { //1: 旧卖座次卡 2.旧卖座储值卡 3:礼品卡,4:礼包卡
        return `${c[countKey]}||份礼包`
      } else {
        return `${c[countKey]}||张票`
      }
  }else {
      let price = Math.round(targetValue)/100
      price = price.toFixed(2) + ""
      let stringPrice = price.split(".")
      if(stringPrice[1] != '00'){
          return `${stringPrice[0]}|${stringPrice[1]}|元`
      }
      return `${stringPrice[0]}||元`
  }
})


/* /**
 *
    @filter 解析卡抵扣信息，包括单位
    @param {couponDetail} coupon 传入卡抵扣详情对象
    @param {key} 需要进行解析的字段
 */
// Vue.filter('couponDeduction', (coupon, valueKey) => {
//     let price = Math.round(coupon[valueKey]) / 100
//     price = price.toFixed(2) + ""
//     let stringPrice = price.split(".")
//     if (stringPrice[1] != '00') {
//         return `${stringPrice[0]}|${stringPrice[1]}`
//     }
//     return `${stringPrice[0]}`
// })


/**
    @filter 返回卡价格的整数部分
    @param {string} info 过滤器’couponPrice‘ 的返回结果
 */
Vue.filter('couponPriceFrist', info => {
    return info.split("|")[0]
})


/**
 *    @filter 返回卡价格的小数部分
 *   @param {string} info 过滤器’couponPrice‘ 的返回结果
 */
Vue.filter('couponPriceSecond', info => {
    if (!info.split("|")[1]) {
        return ""
    }
    return `.${info.split("|")[1]}`
})


/**
    @filter 卡号的样式修改，在第四位后面插入空格
    @param {string} num 卡号
 */
Vue.filter('couponNum', num => {
  if (!num) {
    return ''
  }
  let n = num.split('')
  n.splice(4, 0, " ")
  return n.join("")
})

/**
 * 卡消费明细
 */
// Vue.filter('cardBillListValue', (bill) => {
//   let val = ''
//   // eslint-disable-next-line no-shadow
//   const fmt = (val) => {
//     if (!val) return ''
//     const price = Math.round(val) / 100
//     return `${parseFloat(price.toFixed(2))}`
//   }
//   // eslint-disable-next-line no-confusing-arrow
//   const billType = type => type === 1 ? '-' : '+'
//   switch (bill.businessType) {
//     case 1:
//     case 4:
//       if (bill.unit === 1) {
//         // eslint-disable-next-line no-nested-ternary
//         val = `${billType(bill.billType)}${bill.orderInfo.cardCount}${bill.cardType === 1 ? ' 张票' : bill.cardType === 3 ? ' 份礼包' : ''}`
//       }
//       if (bill.unit === 2) {
//         if (bill.orderInfo.discountType === 1) {
//           val = `${billType(bill.billType)}￥${fmt(bill.orderInfo.cardCategoryAmount)}`
//         } else {
//           val = `${billType(bill.billType)}${fmt(bill.orderInfo.cardAmount)} 积分${bill.cardType === 2 && !bill.orderInfo.hasCashValue ? '' : `<span>(¥${fmt(bill.orderInfo.cardCategoryAmount)})</span`}`
//         }
//       }
//       break;
//     case 5:
//     case 6:
//       if (bill.unit === 1) {
//         // eslint-disable-next-line no-nested-ternary
//         val = `${billType(bill.billType)}${bill.cardCount}${bill.cardType === 1 ? ' 张票' : bill.cardType === 3 ? ' 份礼包' : ''}`
//       } else {
//         val = `${billType(bill.billType)}¥${fmt(bill.cardAmount)}`
//       }
//       break;

//     default:
//       break;
//   }
//   return val
// })
